import React, { Fragment, useState } from "react";
// import styled from "styled-components";

import { Textarea } from "@racepointenergy/gatsby-theme-sitespark/src/components/Html";

import { CheckboxLabel, CheckboxInput } from "components/CheckboxLabel";

import { formPropTypes } from "./prop-types";
import { Input, FormPartial, Title, Range, RangeLabel } from "../styles";

const rangeValues = ["2-6 Hours", "6-12 Hours", "12+ Hours"];

export const DesiredSystemForm = ({ base }) => {
  const [hasHouseChecked, setHasHouseChecked] = useState(false);
  const [hasEssentialChecked, setHasEssentialChecked] = useState(false);
  const [hasOther, setHasOther] = useState(false);
  const [houseRange, setHouseRange] = useState(0);
  const [essentialRange, setEssentialRange] = useState(0);

  return (
    <Fragment>
      <Title>Desired System</Title>
      <FormPartial>
        <CheckboxLabel>
          <CheckboxInput
            name={base("PowerHouseDuringOutage")}
            type="checkbox"
            onChange={isChecked => setHasHouseChecked(isChecked)}
            data-enzyme="house-checkbox"
          />
          <span>
            {
              "I want to power my entire house as usual during a power outage or off-grid scenario"
            }
          </span>
        </CheckboxLabel>
        <Range
          type="range"
          onChange={e => setHouseRange(e.target.value)}
          name={base("PowerEntireHouseRange")}
          value={houseRange}
          disabled={!hasHouseChecked}
          min={0}
          max={rangeValues.length - 1}
          data-enzyme={base("PowerEntireHouseRange")}
        />
        <RangeLabel htmlFor={base("PowerEntireHouseRange")}>
          <span className="hideAccessible">
            {"Length of time to power entire house during outage"}
          </span>
          {rangeValues[houseRange]}
        </RangeLabel>
        <Input
          name={base("PowerEntireHouseRangeValue")}
          type="hidden"
          value={rangeValues[houseRange]}
        />
        <CheckboxLabel>
          <CheckboxInput
            name={base("PowerHomeEfficiently")}
            type="checkbox"
            onChange={isChecked => setHasEssentialChecked(isChecked)}
            data-enzyme="essential-checkbox"
          />
          <span>
            {
              "I want to power only essential parts of my home as efficiently as possible, during a power outage or off-grid scenario:"
            }
          </span>
        </CheckboxLabel>
        <Range
          type="range"
          onChange={e => setEssentialRange(e.target.value)}
          name={base("EssentialRange")}
          value={essentialRange}
          disabled={!hasEssentialChecked}
          min={0}
          max={rangeValues.length - 1}
          data-enzyme={base("EssentialRange")}
        />
        <RangeLabel htmlFor={base("EssentialRange")}>
          <span className="hideAccessible">
            {"Length of time to power essential parts of home during outage"}
          </span>
          {rangeValues[essentialRange]}
        </RangeLabel>
        <Input
          name={base("EssentialRangeValue")}
          type="hidden"
          value={rangeValues[essentialRange]}
        />

        <CheckboxLabel>
          <CheckboxInput type="checkbox" name={base("ReduceCarbonFootprint")} />
          <span>
            {
              "I want to reduce my carbon footprint with a solar and battery system that maximizes the use of the power I generate locally."
            }
          </span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput
            type="checkbox"
            name={base("HaveSensitiveElectronics")}
          />
          <span>
            {
              "I want high-quality and consistent energy (pure sine wave) to protect the sensitive electronics in my home."
            }
          </span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput
            type="checkbox"
            name={base("HaveOtherSystemsDesired")}
            onChange={isChecked => setHasOther(isChecked)}
            data-enzyme="other-checkbox"
          />
          <span>{"Other"}</span>
        </CheckboxLabel>
        <Textarea
          disabled={!hasOther}
          name={base("OtherSystemsDesired")}
          rows="4"
        />
      </FormPartial>
    </Fragment>
  );
};

DesiredSystemForm.propTypes = formPropTypes;
